import React from 'react';
import { useSelector } from 'react-redux';
import NamedLink from '../NamedLink/NamedLink';
import css from './BottomNav.module.css';
import { listeningProfileSetupRoute } from '../../util/accountRole';

// Mobile bottom nav (Sam 6:44 PM): Home, Browse, My Bookings, Messages, Profile.
const I = {
  dash: <><rect x="4" y="4" width="7" height="7" rx="1.5" /><rect x="13" y="4" width="7" height="7" rx="1.5" /><rect x="4" y="13" width="7" height="7" rx="1.5" /><rect x="13" y="13" width="7" height="7" rx="1.5" /></>,
  home: <path d="M3 11l9-7 9 7v9h-6v-6H9v6H3z" />,
  browse: <><circle cx="11" cy="11" r="6.5" /><path d="M16 16l5 5" /></>,
  book: <><rect x="4" y="5" width="16" height="15" rx="2" /><path d="M4 10h16M8 3v4M16 3v4" /></>,
  msg: <path d="M4 12a8 7 0 1 1 3.5 5.8L4 20l1-3.6A6.8 6.8 0 0 1 4 12z" />,
  acct: <><circle cx="12" cy="12" r="3" /><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M5.6 18.4L7 17M17 7l1.4-1.4" /></>,
  me: <><circle cx="12" cy="8" r="3.5" /><path d="M5 20c1-3.6 3.8-5.5 7-5.5s6 1.9 7 5.5" /></>,
};
const earnLink = u => {
  const r = listeningProfileSetupRoute(u || {});
  return { name: r.name, params: r.params, to: r.to };
};
const BottomNav = ({ currentPage }) => {
  const authed = useSelector(s => !!s?.auth?.isAuthenticated);
  // Same earner test as account settings side nav (deploy 112).
  const navUser = useSelector(s => s?.user || {});
  // Sam Oct 24 late: only real earners (published listening/teaching profile) get My Profile.
  // Drafts or a leftover listen/both role flag alone = buyer -> Become an earner.
  const own = navUser.currentUserOwnListing;
  // Sam Oct 25: earners (Listening on and/or Teaching on) always see My Profile, whatever the
  // stored talk/listen role says. Same rule as RoleSwitchesCard: published own listing = earner.
  // Own listing may be a full listing (attributes.state) or a summary (state).
  const ownState = own?.attributes?.state || own?.state || null;
  const isEarner = ownState === 'published' || (!ownState && !!navUser.currentUserHasListings);
  // Sam 2:18 Oct 23: remember this browser has an account (home shows Log in first).
  if (authed && typeof window !== 'undefined') {
    try {
      window.localStorage.setItem('sl_returning', '1');
    } catch (e) {
      // private mode
    }
  }
  const msgOn = false; // Messages removed (Sam Oct 24 late)
  const items = [
    // Sam 12:25 Oct 23: signed in, this tab opens the dashboard, so call it that.
    authed ? ['dash', 'Dashboard', { name: 'DashboardPage' }, ['DashboardPage', 'LandingPage']] : ['home', 'Home', { name: 'LandingPage' }, ['LandingPage']],
    ['browse', 'Search', { name: 'SearchPage' }, ['SearchPage']],
    ['book', 'My Bookings', authed ? { name: 'InboxPage', params: { tab: 'orders' } } : { name: 'LoginPage' }, ['InboxPage']],
    // Sam Oct 24: Messages stays top-right only; this slot is Account -> settings.
    ['acct', 'Account', authed ? { name: 'ContactDetailsPage' } : { name: 'LoginPage' }, ['ContactDetailsPage', 'ManageAccountPage', 'PasswordChangePage', 'StripePayoutPage', 'PaymentMethodsPage']],
    authed && !isEarner
      ? ['me', 'Become an earner', { name: 'BecomeAnEarnerPage' }, ['BecomeAnEarnerPage', 'BecomeAListenerPage', 'TeachPage', 'NewListingPage']]
      : ['me', 'My Profile', authed ? { name: 'MyProfileHubPage' } : { name: 'LoginPage' }, ['MyProfileHubPage']],
  ];
  return (
    <nav className={css.root} aria-label="Main" data-bottom-nav="true">
      {items.map(([k, label, link, pages]) => (
        <NamedLink key={k} {...link} className={pages.includes(currentPage) && !(k === 'book' && msgOn) ? css.on : css.item} data-bottom-nav-item={k}>
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{I[k]}</svg>
          <span>{label}</span>
        </NamedLink>
      ))}
    </nav>
  );
};
export default BottomNav;
